import { Injectable } from '@angular/core';
import { StorageBaseService } from '@core/storage/storage-base.service';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService extends StorageBaseService {
    protected storage: Storage = localStorage;
}
